import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { PATHS } from '@/common';
import {
  Dependent,
  DependentPayload,
  DependentStatusEnum,
} from '@/modules/user/components/ManageProfile/components/Dependents/dependents.types';
import { useAuthStore } from '@/modules/user/stores';
import { getMaskedDependentSsn } from '@/utils';

export const GET_DEPENDENTS_BY_EMPLOYEE_ID_KEY = 'GET_DEPENDENTS_BY_EMPLOYEE_ID_KEY';

const useDependentsQuery = (selectedStatuses?: DependentStatusEnum[]) => {
  const { user } = useAuthStore();
  const { data, isLoading } = useQuery(
    [GET_DEPENDENTS_BY_EMPLOYEE_ID_KEY, user?.employee?.id, selectedStatuses],
    () =>
      api.get<DependentPayload[]>(PATHS.GET_DEPENDENTS_BY_EMPLOYEE_ID(user?.employee?.id), {
        headers: {
          'X-DETAILS-RESOLVERS': 'DEPENDENT',
        },
        params: {
          ...(selectedStatuses ? { statuses: selectedStatuses } : {}),
        },
      }),
    { enabled: Boolean(user?.employee?.id) }
  );

  const formattedData = useMemo(() => data?.data?.map(
      (dependent: DependentPayload): Dependent => ({
        id: toString(dependent?.dependent_id),
        firstName: dependent?.first_name,
        lastName: dependent?.last_name,
        ssn: getMaskedDependentSsn(dependent?.ssn),
        birthOn: dependent?.birth_on,
        relationshipType: dependent?.relationship_type,
        creationSourceType: dependent?.creation_source_type,
        status: dependent?.status,
      })
    ) || [], [data]);

  return {
    formattedData,
    isLoading,
  };
};

export default useDependentsQuery;
